<!-- Content goes through a template so it can render in either branch (ng-content projects only once) -->
<ng-template #content><ng-content></ng-content></ng-template>

<span *ngIf="isAdmin || !plainWhenNotAdmin; else plain" [class]="wrapperClass">
    <span class="avatar-inner">
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </span>
    <span *ngIf="isAdmin" class="admin-badge">ADMIN</span>
</span>

<ng-template #plain>
    <ng-container *ngTemplateOutlet="content"></ng-container>
</ng-template>
